import { animated } from '@react-spring/web'
import { useCallback, useContext, useMemo } from 'react'

import { useBlinkingState } from '../../../lib/preview-animation-hook'
import { type StepDefinitionProps } from '../../../lib/step-definition'
import { FrameBuilderStringsContext } from '../../../contexts/strings-context'
import { FrameBuilderValidationContext } from '../../../contexts/validation-context'

import Button from '../../utility/button'
import ListContainer from '../../utility/list-container'
import PortableText from '../../utility/portable-text'
import ConfigurationDefinition from '../configuration-definition'
import PassepartoutSizeList from './passepartout-size-list'

const PassepartoutDefinition = ({
  number,
  onClose,
  className,
}: StepDefinitionProps) => {
  const { validationMessages } = useContext(FrameBuilderValidationContext)
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)

  const [sizeOpacity, setIsSizeBlinking] = useBlinkingState()

  // TODO: Wrong way to check for valid state!
  const isValidSelection = useMemo(
    () =>
      !validationMessages?.passepartoutSizePreview &&
      !validationMessages?.passepartoutColorPreview,
    [validationMessages],
  )

  const handleOkClick = useCallback(() => {
    if (isValidSelection) {
      onClose()
    }

    if (!isValidSelection) {
      setIsSizeBlinking(true)
    }
  }, [isValidSelection, setIsSizeBlinking, onClose])

  return (
    <ConfigurationDefinition
      number={number}
      onClose={onClose}
      title={frameBuilderStrings.passepartoutStepTitle}
      className={className}
    >
      <div className="flex flex-col px-6 space-y-6">
        <animated.div
          style={{
            opacity: sizeOpacity,
          }}
        >
          <ListContainer gapSize="sm">
            <PassepartoutSizeList />
          </ListContainer>
        </animated.div>

        <div className="flex justify-between mt-6">
          <Button
            size="small"
            isVisuallyDisabled={!isValidSelection}
            onClick={handleOkClick}
            className="w-[49%] grow-0 shrink-0"
          >
            {frameBuilderStrings.controlOkLabel}
          </Button>
        </div>
      </div>

      {frameBuilderStrings.passepartoutStepFooter && (
        <>
          <hr className="bg-gray-300" />
          <div className="flex flex-col px-6 space-y-6">
            <PortableText
              content={frameBuilderStrings.passepartoutStepFooter}
            />
          </div>
        </>
      )}
    </ConfigurationDefinition>
  )
}

export default PassepartoutDefinition
